import React from "react";
import styled from "styled-components";

function Header() {
  return <HeaderContainer></HeaderContainer>;
}

export default Header;

const HeaderContainer = styled.div`
  height: 120px;
  width: 100%;
`;
